// The design-system InputNumber reports `number | null` (null = cleared). Forms that keep
// their numeric fields as text (and treat '' as "not set") store this instead.
export const toNumberText = (value) => (value == null ? '' : String(value));
